<template>
  <div id="wdw-create-valuelist-form">
    <!-- <button v-if="showBackButton" class="btn btn-primary" @click="closeThoughtForm()">Zurück zur Liste</button> -->
    <div>
      <div class="row" v-for="(valid, index) in internalValidationArray" :key="index">
        <div class="col-md-6 form-group">
          <label class="labelClassName" :for="'valuelist-entry-' + index">
            <b>{{ index + 1 }}. Wert eingeben</b>
            <button
              v-if="externalValueArray[index]"
              class="btn btn-link btn-delete-entry text-danger ps-1"
              @click="removeIndex(index)"
            >
              <font-awesome-icon icon="trash-alt" />
            </button>
          </label>
          <input
            :id="'valuelist-entry-' + index"
            type="text"
            :name="'valuelist-entry-' + index"
            class="form-control"
            :class="{ error: !valid }"
            v-model="externalValueArray[index]"
          />
          <span
            :id="'valuelist-entry-' + index + '-error'"
            v-show="!valid"
            class="text-danger form-error-message"
            aria-atomic="true"
          >
            Dieser Wert existiert bereits. Bitte geben Sie unterschiedliche Werte ein
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  onBeforeMount,
  toRefs,
  ref,
  watch,
  computed,
  toRef,
  unref,
  reactive,
  readonly,
  watchEffect,
  onMounted,
} from 'vue';

export default {
  name: 'ValuelistForm',
  emits: ['changed-entries'],
  props: {},

  setup(props, context) {
    const externalValueArray = ref([]);
    const internalValidationArray = ref([true]);

    //--------------------------------COMPUTED-----------------------------------
    // const user = computed(() => {
    //   return userStore.getState().user;
    // });

    //+------------------------+
    //|     methods      |
    //+------------------------+

    // add a new input field for frontend (using "internalValidationArray")
    const evaluateAddingNewEntry = () => {
      const extLength = externalValueArray.value.length;
      const intLength = internalValidationArray.value.length;
      if (externalValueArray.value[extLength - 1] !== '' && intLength === extLength) {
        internalValidationArray.value.push(true);
      }
    };

    const validateAll = () => {
      const alreadySeen = {};
      externalValueArray.value.forEach((str, index) => {
        if (alreadySeen[str]) internalValidationArray.value[index] = false;
        else internalValidationArray.value[index] = true;
        alreadySeen[str] = true;
      });
    };

    const removeIndex = index => {
      internalValidationArray.value.splice(index, 1); // 2nd parameter means remove one item only
      externalValueArray.value.splice(index, 1); // 2nd parameter means remove one item only
      validateAll();
    };

    // constantly update parent if anything changes
    watch(
      () => externalValueArray,
      (newArr, oldArr) => {
        evaluateAddingNewEntry();
        validateAll();
        context.emit('changed-entries', {
          entries: externalValueArray.value,
          validation: internalValidationArray.value,
        });
      },
      { deep: true }
    );

    return {
      //-------------vars--------------
      internalValidationArray,
      externalValueArray,
      //-------------methods--------------
      removeIndex,
    };
  },
};
</script>

<style scoped>
.form-group {
  margin-bottom: 15px;
}
input {
  width: 80%;
}
.btn-delete-entry {
  line-height: 1;
}
</style>
